var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ubru-coffee-return"},[_c('ubruCoffeeRetrun')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }